import {
    RecursoTransferenciaInfoGrid,
    RecursoTransferenciaInfoList,
} from '@components/recurso/movimentacao/RecursoTransferenciaInformacao.tsx';
import {RecursosPage} from "@components/recurso/pages/RecursosPage.tsx";
import {useApi} from "@contexts/hooks/api/useApi.ts";
import {_RecursosEndpoints} from '@localization/siteMap/endpoints/_RecursosEndpoints.ts';
import {DefaultPageProps} from '@models/DefaultProps.ts';
import {IRecurso} from "@models/recurso/IRecurso.ts";
import {IRecursoTransferenciaSolicitacao} from '@models/recurso/IRecursoTransferencia.ts';
import {CheckOutlined} from "@mui/icons-material";
import {Grid, IconButton, Paper, Tab, Tabs, Typography} from '@mui/material';
import {DefaultContainer} from '@shared/DefaultContainer.tsx';
import {MoneyInputEntry} from "@shared/specialComponents/InputEntry.tsx";
import React, {useEffect, useState} from 'react';
import {useLocation, useNavigate, useSearchParams} from 'react-router';

export interface RecursoTransferenciaPageProps extends DefaultPageProps {
}

type tabs = 'Informacoes' | 'Recursos'

export const RecursoTransferenciaPage: React.FC<RecursoTransferenciaPageProps> = (props) => {

    // const [pagination, setPagination] = useState<IPagination>({page: 1, pageSize: 10});
    const [tab, setTab] = useState<tabs>('Informacoes');
    const [transferencia, setTransferencia] = useState<IRecursoTransferenciaSolicitacao | undefined>(); // Define the type according to your needs
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const location = useLocation();
    const {Get} = useApi();

    const recursoId = searchParams.get('recursoId');
    const transferenciaId = searchParams.get('transferenciaId');

    useEffect(() => {

        if (transferenciaId) {
            const n = Number(transferenciaId);

            if (isNaN(n)) {
                return;
            }

            Get(_RecursosEndpoints.GetSolicitacaoTransferenciaRecurso({
                transferenciaId: n,
            }, {page: 1, pageSize: 1})).then(x => {
                if (x.hasData) {
                    setTransferencia(x.items[0]);
                }
            })
        }


    }, [transferenciaId, recursoId]);

    useEffect(() => {
        setTab(location.hash.slice(1) as tabs || 'Informacoes');
    }, [location.hash]);

    return (
        <DefaultContainer titulo={'Transferencia entre recursos'} component={Paper} size={'large'} {...props}>
            {transferencia && <Grid>
                <Grid>
                    <RecursoTransferenciaInfoList value={transferencia}/>
                </Grid>
                <Grid my={0.5}>
                    <Tabs value={tab} onChange={(_e, v) => {
                        navigate({
                            pathname: location.pathname,
                            search: location.search,
                            hash: v,
                        });
                    }}>
                        <Tab label={'Informações'} value={'Informacoes'}/>
                        <Tab label={'Recursos'} value={'Recursos'}/>
                    </Tabs>
                </Grid>
                <Grid size={12}>
                    {tab === 'Informacoes' && <RecursoTransferenciaInfoGrid value={transferencia}/>}
                    {tab === 'Recursos' && <RecursosPage disableHeader disableTitle slotProps={{
                        RecursoItem: {
                            EndComponent: (r) => r.id != transferencia.recursoId ?
                                <TransferenciaRecursoComponent transferencia={transferencia}
                                                               recurso={r}/> :
                                <Typography color={'info'} textAlign={'center'}>Recurso de origem</Typography>
                        }
                    }} filtros={{
                        ativo: true,
                        emVigencia: true,
                    }}
                    />}
                </Grid>
            </Grid>}

        </DefaultContainer>
    );
};

function TransferenciaRecursoComponent(props: { recurso: IRecurso, transferencia: IRecursoTransferenciaSolicitacao }) {
    const {recurso, transferencia} = props;
    const [valor, setValor] = useState<number | undefined>(Math.min(recurso.valorDisponivel ?? 0, transferencia.valorSolicitado));

    return (
        <Grid container alignItems={'center'}>
            <Grid size={'grow'}>
                <MoneyInputEntry value={valor}
                                 onChange={(v) => setValor(v)}
                                 textFieldProps={{size: 'small', variant: 'standard'}}
                                 label={'Valor a transferir'} clampValues={{
                    min: 0,
                    max: Math.min(recurso.valorDisponivel ?? 0, transferencia.valorSolicitado)
                }}/>
            </Grid>
            <Grid>
                <IconButton>
                    <CheckOutlined/>
                </IconButton>
            </Grid>

        </Grid>
    );
}